
  import { Vue, Component, Prop } from "vue-property-decorator";

  import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
  import UIButton from "@/components/button/ui-button.vue";
  import FormTextarea from "../form/FormTextarea.vue";
  import CONTRACTOR_NOTE from "@/apollo/contractors/CreateContractorNote.gql"
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages"
  import UPDATE_CONTRACTOR_NOTE from "@/apollo/contractors/UpdateContractorNote.gql"

  interface NotesFormData {
    id?: string;
    manager_id: string;
    contractor_id: string;
    note: string;
  }

  @Component({
    components: {
      ModalFullScreen,
      UIButton,
      FormTextarea,
    },
  })
  export default class AddNotesModal extends Vue {
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, default: ""}) readonly note!: string;
    @Prop({ type: String, required: true}) readonly currentUserId!: string;
    @Prop({type: String, required: true }) readonly contractorId!: string;
    @Prop({ type: String, required: true }) readonly contractorUserId!: string;
 
    contractorNote: string = this.note
    processing: boolean = false

    notes: NotesFormData = {
      id: undefined,
      manager_id: this.currentUserId,
      contractor_id: this.contractorId,
      note: this.contractorNote
    }
    onModalClose(): void {
      this.$emit('close')
    }
    handleCancel(): void {
      this.$emit('close')
    }
    async onAdd(): Promise<void> {
      try { 
            this.processing = true;

            await this.$apollo.mutate({
              mutation: CONTRACTOR_NOTE,
              variables: {
                  contractor_id: this.contractorId,
                  manager_id: this.currentUserId,
                  note: this.contractorNote
              },
            });
        this.$emit('add')
        this.$eventBus.emit(
          NOTIFICATION,
          Message.successMessage("Note added successfully")
        );
      } catch(err) {
        this.$eventBus.emit(
          NOTIFICATION,
          Message.errorMessage(err.message)
        );
      } finally {
        this.processing = false
      }
    }
  }
 
